// extracted by mini-css-extract-plugin
module.exports = {"container":"floating-actions_container__yTZHn"};